import Axios from 'axios';
const RESOURCE = '/RegistroCivil';


const RESOURCE_NAME_BRANDS = RESOURCE + '/GetBrands';
const RESOURCE_NAME_MODELS = RESOURCE + '/GetModels/';
const RESOURCE_NAME_YEARS = RESOURCE + '/GetYears/';
const RESOURCE_NAME_INFO = RESOURCE + '/GetAsociacion/';
const RESOURCE_NAME_SETINFO = RESOURCE + '/SetDiccionario';
const RESOURCE_NAME_REMOVEINFO = RESOURCE + '/RemoveDiccionario';

const oldAPI = process.env.VUE_APP_WS_ENDPOINT;

export default {

  filters: {
    brands() {
      return Axios.get(RESOURCE_NAME_BRANDS);
    },
    models(brand, year) {
      return Axios.get(RESOURCE_NAME_MODELS + brand + "/" + year);
    },
    years(brand) {
      return Axios.get(RESOURCE_NAME_YEARS + brand)
    },
    fuels() {
      return Axios.get(`${oldAPI}/Caracteristicas/Combustibles`);
    },
    bodytypes() {
      return Axios.get(`${oldAPI}/Carrocerias/Categoria/1`);
    },
    getInfo(brand, year, model) {
      return Axios.get(RESOURCE_NAME_INFO + brand + "/" + year + "/" + model);
    }
  },
  save: {
    setInfo(data) {
      return Axios.post(RESOURCE_NAME_SETINFO, data)
    },
    deleteInfo(data) {
      return Axios.delete(RESOURCE_NAME_REMOVEINFO, {
        data: data
      })
    }
  }
};